import { OwnerModelDTO } from '../../../../Profile/Accounts/api/useAccountsQuery';
import {
  AccountType,
  AccountTypeOptionsDTO,
} from '../../../../Profile/Accounts/api/useAccountsOptionsQuery';

interface Params {
  accountTypes: AccountTypeOptionsDTO[];
  selectedAccountType: AccountType;
}

export const useAccountOwnership = ({ accountTypes, selectedAccountType }: Params) => {
  const accountOptions = accountTypes.find(option => option.AccountType === selectedAccountType);

  const ownerOptions = accountOptions?.OwnerOptions ?? {};

  return {
    accountOwnersOptions: Object.keys(ownerOptions).reduce(
      (accumulator, groupKey) =>
        accumulator.concat(
          (ownerOptions[groupKey] || []).map(accountOwner => ({
            label: accountOwner.Name,
            value: accountOwner.Id,
            groupId: groupKey.toLowerCase(),
          })),
        ),
      [],
    ) as { label: string; value: string; groupId: string }[],
    accountOwnersGroups: Object.keys(ownerOptions).map(groupKey => ({
      groupId: groupKey.toLowerCase(),
      title: groupKey,
    })),
    ownerOptions: Object.keys(ownerOptions)
      .map(key => ownerOptions[key])
      .filter(Boolean)
      .flat() as OwnerModelDTO[],
    allowsUnequalOwnership: accountOptions ? accountOptions.AllowsUnequalOwnership : false,
  };
};
